/**
 * Hero — Split Duotone
 * Thread Drop
 *
 * Expects GSAP (and optionally ScrollTrigger) to already be loaded globally
 * as part of theme.js's animation bootstrap. Lenis, if present, is only
 * used to sync scroll-driven parallax — this section's primary animation
 * is a single orchestrated load-in, not scroll-triggered reveals.
 */
(function () {
  var sections = document.querySelectorAll('.hero-split[data-animate="true"]');
  if (!sections.length) return;

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  sections.forEach(function (section) {
    if (typeof gsap === 'undefined' || prefersReducedMotion) {
      // No animation library, or the user asked for none: show content as-is.
      section.classList.add('hero-split--ready');
      return;
    }

    var image = section.querySelector('[data-hero-media]');
    var headingLines = section.querySelectorAll('.hero-split__heading-line-inner');
    var fadeEls = section.querySelectorAll('[data-hero-fade]');

    gsap.set(headingLines, { yPercent: 110 });
    gsap.set(fadeEls, { autoAlpha: 0, y: 16 });
    gsap.set(image, { clipPath: 'inset(0 0 100% 0)' });

    var tl = gsap.timeline({
      defaults: { ease: 'power4.out' },
      onComplete: function () {
        section.classList.add('hero-split--ready');
      },
    });

    tl.to(image, {
      clipPath: 'inset(0 0 0% 0)',
      duration: 1.1,
      ease: 'power3.inOut',
    })
      .to(
        headingLines,
        {
          yPercent: 0,
          duration: 0.9,
          stagger: 0.045,
        },
        '-=0.55'
      )
      .to(
        fadeEls,
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
        },
        '-=0.45'
      );

    // Subtle scroll parallax on the image, synced to Lenis if it's running.
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.to(image, {
        yPercent: 8,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });
    }
  });
})();
